export default [
    {
        path: 'analysis-app',
        name: 'AnalysisApp',
        meta: {
            isDynamic: true,
            id: '万药通APP',
            inTab: true
        },
        component: () => import(/* webpackChunkName: "DownloadCenter" */'@/views/analysis/app')
    }
]